import styled, { keyframes } from 'styled-components';

import { ReactComponent as CloseIcon } from '../../../Static/icons/close.svg';

import S from '../variables';

const spin = keyframes`
0% {
  transform: rotate(0);
}
100% {
  transform: rotate(1turn);
}
`;

export const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 22px;
  right: 22px;
  fill: ${S.mainBlackText};
  cursor: pointer;
  &:hover {
    fill: black;
    transform: scale(1.2);
  }
  &:active {
    transform: scale(0.8);
    transition: none;
  }
  transition: fill ${S.trFast}, transform ${S.trFast};
  & * {
    pointer-events: none;
  }
`;

export const StyledForm = styled.form`
  position: relative;
  margin: auto;
  padding: 53px 18px 6px;
  background: #fff;
  border-radius: 5px;
  width: 280px;
  transform: scale(0.5);
  opacity: 0;
  transition: transform ${S.trFast}, opacity ${S.trFast};
  & > ul > li {
    &:not(:last-child) {
      margin-bottom: 17px;
    }
  }
  &.entered {
    transform: scale(1);
    opacity: 1;
  }
  @media screen and (min-width: ${S.phone}) {
    width: 360px;
  }
  @media screen and (min-width: ${S.tablet}) {
    padding: 48px 78px 28px;
    width: 480px;
  }
  @media screen and (min-width: ${S.desktop}) {
    width: 522px;
  }
`;

export const StyledFormTitle = styled.h2`
  font-family: 'Judson', serif;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: ${S.accentGold};
  text-align: center;
  @media screen and (min-width: ${S.tablet}) {
    font-size: 30px;
    margin-bottom: 48px;
  }
`;

export const StyledFormLabel = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
  &.title {
    font-size: 12px;
  }
`;

export const StyledErrors = styled.div`
  position: relative;
  height: 20px;
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  & > span {
    transform: translateX(-100%);
    opacity: 0;
    font-size: 12px;
    transition: transform ${S.trSlow}, opacity ${S.trFast};
    &.error {
      color: ${S.lightRedBg};
      transform: translateX(0);
      opacity: 1;
    }
    &.success {
      color: ${S.lightGreenBg};
      transform: translateX(0);
      opacity: 1;
    }
    &.spinner {
      position: absolute;
      top: -40px;
      right: 20px;
      width: 0;
      height: 16px;
      border: 2px solid white;
      border-top-color: transparent;
      border-radius: 50%;
      opacity: 0;
      transform: scale(0);
      transition: transform ${S.trSlow}, opacity ${S.trFast};
      &.loading {
        opacity: 1;
        transform: scale(1);
        animation: 1s ${spin} linear infinite;
        width: 16px;
      }
    }
  }
`;

export const StyledConfirmButtons = styled.ul`
  width: 100%;
  display: flex;
  justify-content: space-between;
  & > li {
    width: calc(50% - 4px);
  }
`;
